import { api } from "../lib/api";

export interface ChatMessage {
	content: string | unknown;
	createdAt: Date;
}

export interface Chat {
	id: string;
	title: string;
	createdAt: Date;
	lastMessage: ChatMessage | null;
}

interface ChatsApiResponse {
	chats: Chat[];
}

/**
 * Get all user's chats with their last message
 */
export async function getUserChats(): Promise<Chat[]> {
	try {
		const response = await api.get<ChatsApiResponse>("/api/chats");
		return response.data.chats;
	} catch (error: unknown) {
		if (error && typeof error === "object" && "response" in error) {
			const axiosError = error as {
				response?: { data?: { error?: string } };
			};
			if (axiosError.response?.data?.error) {
				throw new Error(axiosError.response.data.error);
			}
		}
		throw new Error("Failed to fetch chats");
	}
}
